import type { TypographyVariantsOptions } from '@mui/material/styles';
import { fontScale, primaryFontList, secondaryFontList } from '../fonts';

const typography = (textColor: string): TypographyVariantsOptions => ({
  module: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['12']}rem`,
    fontFamily: primaryFontList,
  },
  h1: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['11']}rem`,
    fontFamily: primaryFontList,
  },
  h2: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['9']}rem`,
    fontFamily: primaryFontList,
  },
  h3: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['7']}rem`,
    fontFamily: primaryFontList,
  },
  h4: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['5']}rem`,
    fontFamily: primaryFontList,
  },
  h5: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['4']}rem`,
    fontFamily: primaryFontList,
  },
  h6: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['3']}rem`,
    fontFamily: primaryFontList,
  },
  compactSubtitle1: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['4']}rem`,
    fontFamily: secondaryFontList,
  },
  compactSubtitle2: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['2']}rem`,
    fontFamily: secondaryFontList,
  },
  compactSubtitle3: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['1']}rem`,
    fontFamily: secondaryFontList,
  },
  subtitle1: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['2']}rem`,
    fontFamily: primaryFontList,
  },
  subtitle2: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['1']}rem`,
    fontFamily: primaryFontList,
  },
  subtitle3: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['0']}rem`,
    fontFamily: primaryFontList,
  },
  subtitle4: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['-1']}rem`,
    fontFamily: primaryFontList,
  },
  article: {
    color: textColor,
    fontWeight: 'normal',
    fontSize: `${fontScale['1']}rem`,
    fontFamily: primaryFontList,
  },
  body1: {
    fontSize: `${fontScale['0']}rem`,
    fontFamily: primaryFontList,
  },
  body2: {
    fontSize: `${fontScale['-1']}rem`,
    fontFamily: primaryFontList,
  },
  caption: {
    fontSize: `${fontScale['-2']}rem`,
    fontFamily: primaryFontList,
  },
  overline: {
    fontSize: `${fontScale['-3']}rem`,
    fontFamily: primaryFontList,
  },
  micro: {
    fontSize: `${fontScale['-4']}rem`,
    fontFamily: primaryFontList,
  },
  button: {
    textTransform: 'capitalize',
    fontWeight: 'normal',
    fontFamily: primaryFontList,
  },
});

export default typography;
